import React from 'react'

import { theme } from '../../theme'
import { SIconSpan } from '../../../common/styles/Icons'

interface IalertIconProps {
    fill?: string
    size?: number
    title?: string
    id?: string
}

const SignalIcon = ({
    fill = theme.brandColors.CA_Black,
    size = 14,
    title,
    id = 'info-icon',
}: IalertIconProps): React.ReactElement => {
    return (
        <SIconSpan title={title} id={id} size={size}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="100%"
                height="100%"
                viewBox="0 0 24 24"
                fill="none"
                stroke={fill}
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="feather feather-wifi-off"
            >
                <path d="M5 12.55a11 11 0 0 1 14.08 0"></path>
                <path d="M1.42 9a16 16 0 0 1 21.16 0"></path>
                <path d="M8.53 16.11a6 6 0 0 1 6.95 0"></path>
                <line x1="12" y1="20" x2="12.01" y2="20"></line>
            </svg>
        </SIconSpan>
    )
}

export default SignalIcon
